module.exports = "pegasus_template/assets/facebook-chiclet.png";